/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-11 14:48:40
 *
 *******************************************************/
// @flow

export const PRIORITY_LEVEL = [
  { label: 'AdminHTML.SuggestionDictionary.SuggestionDictionary.priority_High', value: 3 },
  { label: 'AdminHTML.SuggestionDictionary.SuggestionDictionary.priority_Normal', value: 2 },
  { label: 'AdminHTML.SuggestionDictionary.SuggestionDictionary.priority_Low', value: 1 }
];

// Display 10 suggestions per page
export const NUMBER_SUGGESTION_PER_PAGE = 10;
